"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCreateSchema = void 0;
var zod_1 = require("zod");
exports.UserCreateSchema = zod_1.z.object({
    name: zod_1.z.string(),
    email: zod_1.z.string(),
    password: zod_1.z.string(),
});
